import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthTokenStoreService } from './auth-token-store.service';
import {
	AuthTokenResponse,
	OtpValidationError,
} from 'src/app/models/auth/auth-token.models';

@Injectable({ providedIn: 'root' })
export class ExternalAuthService {
	private readonly baseUrl = `${environment.urlBase}/onboarding`;

	constructor(
		private http: HttpClient,
		private authTokenStore: AuthTokenStoreService
	) {}

	fetchInitialToken(cfToken: string): Observable<string> {
		const headers = new HttpHeaders({
			accept: 'text/plain',
			'x-api-version': '1.0',
			'x-channel-id': 'ONB',
			'X-IBM-Client-Id': environment.clientID,
		});

		return this.http
			.get<AuthTokenResponse>(
				`${this.baseUrl}/initial_steps_auths/${encodeURIComponent(cfToken)}`,
				{ headers }
			)
			.pipe(
				map(response => {
					const token = response.modelo.access_token;
					this.authTokenStore.setInitialToken(token, response.modelo.expires_in);
					return token;
				})
			);
	}

	fetchEvaluationToken(otp: string, idPersona: string, tipoMedio: number): Observable<string> {
		const initialToken = this.authTokenStore.getInitialToken();
		const headersConfig: { [name: string]: string } = {
			accept: 'text/plain',
			'x-api-version': '1.0',
			'x-channel-id': 'ONB',
			'X-IBM-Client-Id': environment.clientID,
		};
		if (initialToken) {
			headersConfig['Authorization'] = `Bearer ${initialToken}`;
		}

		return this.http
			.get<AuthTokenResponse>(
				`${this.baseUrl}/evaluation_steps_auths/${encodeURIComponent(otp)}/${encodeURIComponent(idPersona)}/${tipoMedio}`,
				{ headers: new HttpHeaders(headersConfig) }
			)
			.pipe(
				map(response => {
					const token = response.modelo.access_token;
					this.authTokenStore.setEvaluationToken(
						token,
						response.modelo.expires_in
					);
					return token;
				}),
				catchError(error => {
					if (error?.status === 400) {
						const message = parseOtpErrorMessage(error.error);
						return throwError(() => new OtpValidationError(message));
					}
					return throwError(() => error);
				})
			);
	}
}

function parseOtpErrorMessage(errorBody: unknown): string {
	try {
		const outer = errorBody as { detail?: string };
		if (!outer.detail) return 'Error al validar OTP';
		const match = outer.detail.match(/\{[^{}]*"detail"\s*:\s*"([^"]+)"[^{}]*\}/);
		if (match?.[1]) return match[1];
		return 'Error al validar OTP';
	} catch {
		return 'Error al validar OTP';
	}
}
